export { default as Hero } from "./Hero"
export { default as SEO } from "./SEO"
export { default as Section } from "./Section"
export { default as Pricing } from "./Pricing"
export { default as Portlet } from "./Portlet"
export { default as Paper } from "./Paper"
export { default as Faq } from "./Faq"
export { default as Feature } from "./Feature"
export { default as Integration } from "./Integration"
